import { render } from "./server-crash.vue?vue&type=template&id=69105074&scoped=true"
import script from "./server-crash.vue?vue&type=script&lang=js"
export * from "./server-crash.vue?vue&type=script&lang=js"

import "./server-crash.vue?vue&type=style&index=0&id=69105074&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69105074"]])

export default __exports__